<template lang="html">
  <div>
    <div class="con_wrap">
      <h1 class="title" @click="backHome()"> &#60; 가이드</h1>
    </div>
    <h1 class="logo">
      <img src="../../../../assets/images/introMain/logo.png" alt="">
    </h1>
  <swiper :options="swiperOption" :dir="$vs.rtl ? 'rtl' : 'ltr'" :key="$vs.rtl">
    <swiper-slide id="slide1">
      <div>
        <img class="slide1_img1" src="../../../../assets/images/introPlan/slide1_img1.png" alt="">
        <img class="circle1" src="../../../../assets/images/introPlan/circle1.gif" alt="">
      </div>
          <p class="speech1">
              <span>플래너</span>에 대해 함께 알아볼까요?
          </p>
          <p class="speech2">
              먼저 <span>할일</span>을 추가해봐요 :)
          </p>
    </swiper-slide>
    <swiper-slide id="slide2">
      <div>
        <img class="slide2_img1" src="../../../../assets/images/introPlan/slide1_img3.png" alt="">
        <img class="slide2_img2" src="../../../../assets/images/introPlan/slide1_img4.png" alt="">
      </div>
      <p class="speech3">
          <span>과목</span>을 <span>선택</span>하고 할일을 적으면 끝!
      </p>
    </swiper-slide>
    <swiper-slide id="slide3">
      <div>
        <img class="slide3_img1" src="../../../../assets/images/introPlan/slide2_img1.png" alt="">
        <img class="slide3_img2" src="../../../../assets/images/introPlan/timer.gif" alt="">
        <img class="slide3_img3" src="../../../../assets/images/introPlan/slide2_img3.png" alt="">
        <img class="circle2" src="../../../../assets/images/introPlan/circle2.gif" alt="">
      </div>
      <p class="speech4">
          <span>추가된 일정</span>은<br> 버튼을 눌러
          <span>시작</span>할 수 있어요 :)
      </p>
      <p class="speech4_1">
        <span>스톱워치</span> 기능으로 <br>
        내가 얼마나 <span>집중</span> 했는지 <span>체크</span>!
      </p>
    </swiper-slide>
    <swiper-slide id="slide4">
      <div>
        <img class="slide4_img1" src="../../../../assets/images/introPlan/slide2_img2.png" alt="">
      </div>
      <p class="speech5">
          할 일을 <span>종료</span> 하고 싶나요?
      </p>
      <span class="icon">
        <img src="../../../../assets/images/introPlan/check_box.png" alt="">
      </span>
    </swiper-slide>
    <swiper-slide id="slide5">
      <div>
        <img class="slide5_img1" src="../../../../assets/images/introPlan/slide3_img1.png" alt="">
        <img class="slide5_img2 banner" src="../../../../assets/images/introPlan/slide3_img2_1.png" alt="">
        <img class="slide5_img3" src="../../../../assets/images/introPlan/slide3_img3.png" alt="">
        <img class="slide5_img4" src="../../../../assets/images/introPlan/slide3_img4.png" alt="">
        <img class="circle4" src="../../../../assets/images/introPlan/circle4.gif" alt="">
        <img class="slide5_img5" src="../../../../assets/images/introPlan/slide5_img5.png" alt="">
        <img class="slide5_img6" src="../../../../assets/images/introPlan/slide5_img6.png" alt="">
      </div>
      <p class="speech5">
          <span>일정</span>을 마쳤다면 <br>
          <span>끝내기 버튼</span>을 눌러보세요 :)

      </p>
    </swiper-slide>
    <swiper-slide id="slide6">
      <div>
        <img class="slide6_img1" src="../../../../assets/images/introPlan/slide6_img1.png" alt="">
        <img class="slide6_img2" src="../../../../assets/images/introPlan/slide6_img2.png" alt="">
        <img class="circle5" src="../../../../assets/images/introPlan/circle5.gif" alt="">
        <img class="slide6_img3" src="../../../../assets/images/introPlan/slide6_img3.png" alt="">

      </div>
      <p class="speech6">
          <span>캘린더</span>를 통해 <span>일정 체크</span>과 앞으로의 <span>계획</span>까지! <br>
          지금 바로 시작해볼까요?

      </p>
    </swiper-slide>
  </swiper>
  <div class="swiper-pagination"></div>
  <div class="skip">
      <p><a href="#">계획 하러 가기</a></p>
  </div>
</div>
</template>

<script src="https://ajax.googleapis.com/ajax/libs/jquery/3.6.0/jquery.min.js"></script>
<script>

import '../../../../assets/css/intro/test/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'

export default {
  mounted() {
    $(".slide1_img1 , .slide1_img2").stop().fadeIn();
    $(".speech1").stop().fadeIn();
    $(".slide2_img2").css("width" , "300px")

      var gifSource = $('.circle1').attr('src');
        $('.circle1').attr('src', "");
        $('.circle1').attr('src', gifSource +"?"+new Date().getTime());

        $(".circle1").delay(600).fadeIn();
        $(".speech1").delay(1200).fadeOut(function(){
            $(".speech2").fadeIn();
        })
  },
  methods: {
    backHome() {
      this.$router.push('/pages/intro-main')
    },
  },
    data() {
        return {
            swiperOption: {
                pagination: {
                    el: '.swiper-pagination',
                    clickable:true
                },
                on: {
                  transitionStart: function(){
                    $(".swiper-slide div img , .icon").not(this).stop().fadeOut();
                    $(".swiper-slide p , .icon").not(this).stop().hide();
                  },
                  transitionEnd: function(){
                    var currentIndex = this.realIndex;

                    switch(currentIndex) {
                      case 0 :  $(".slide1_img1 , .slide1_img2").stop().fadeIn();
                                $(".speech1").stop().fadeIn();
                                $(".slide2_img2").css("width" , "300px")

                                var gifSource = $('.circle1').attr('src');
                                    $('.circle1').attr('src', "");
                                    $('.circle1').attr('src', gifSource +"?"+new Date().getTime());

                                $(".circle1").delay(600).fadeIn();
                                  $(".speech1").delay(1200).fadeOut(function(){
                                      $(".speech2").fadeIn();
                                  })
                                break;

                      case 1 : $(".slide2_img1").fadeIn();
                                $(".speech3").delay(300).fadeIn();
                                $(".slide2_img2").delay(300).fadeIn(900);
                                $(".slide2_img2").delay(600).queue(function(){
                                  $(this).css({
                                    "width" : "320px",
                                    "transition" : "all 0.5s ease"
                                  })
                                }).dequeue();
                                $(".speech3").delay(900).stop().fadeIn();
                                $(".slide3_img3").css({
                                  "width" : "300px",
                                  "transform" : "translate(-50% , -50%)",
                                });
                                break;

                      case 2 : $(".slide3_img1").stop().fadeIn().queue(function(){

                                  var gifSource2 = $('.circle2').attr('src');
                                  $('.circle2').attr('src', "");
                                  $('.circle2').attr('src', gifSource2+"?"+new Date().getTime());

                                  $(".speech4").delay(600).fadeIn();
                                  $(".circle2").delay(600).fadeIn(function(){
                                    $(".circle2").delay(600).fadeOut(400);

                                    var gifSource3 = $('.slide3_img2').attr('src');
                                    $('.slide3_img2').attr('src', "");
                                    $('.slide3_img2').attr('src', gifSource3+"?"+new Date().getTime());

                                    $(".slide3_img2 , .slide3_img3").delay(1400).fadeIn(300)

                                    $(".speech4").delay(2400).fadeOut();
                                    })
                                }).dequeue();

                                $(".speech4_1").delay(5500).fadeIn();
                                $(".slide2_img2").css("width" , "300px");

                                $(".icon").css({
                                  "transform" : "translate(-10% , -35%) scale(1)",
                                  "box-shadow" : "" ,
                                  "trasition" : ""
                                })
                                break;

                      case 3 : $(".slide4_img1 , .slide4_img2").fadeIn();
                                $(".speech5").delay(300).stop().fadeIn();

                                $(".slide4_img2").delay(600).queue(function(){
                                  $(".slide4_img2").css({
                                    "width" : "350px",
                                    "transition" : "all 1s ease"
                                  });
                                })
                                $(".icon").delay(900).stop().fadeIn(300)
                                $(".icon").queue(function(){
                                  $(".icon").css({
                                    "transform" : "translate(-10% , -35%) scale(1.2)",
                                    "transition" : "all 1s ease",
                                    "box-shadow" : "0 2px 4px 0 rgb(0 0 0 / 15%), 0 3px 10px 0 rgb(0 0 0 / 14%)"
                                  }).dequeue();
                                });
                                $(".banner").css({
                                  "width" : "220px",
                                  "box-shadow" : "",
                                  "trasition" : ""
                                })
                                break;

                      case 4 : $(".slide5_img1 , .banner").fadeIn();
                                $(".banner").delay(400).queue(function(){
                                  $(".banner").css({
                                    "width" : "230px" ,
                                    "transition" : "all 1s ease",
                                    "box-shadow" : "0 4px 8px 0 rgb(0 0 0 / 15%), 0 6px 20px 0 rgb(0 0 0 / 14%)"
                                  }).dequeue();
                                })
                                var gifSource4 = $('.circle4').attr('src');
                                $('.circle4').attr('src', "");
                                $('.circle4').attr('src', gifSource4+"?"+new Date().getTime());

                                $(".circle4").delay(1500).fadeIn();
                                $(".circle4").delay(1500).fadeOut(300, function(){
                                  $(".slide5_img5").fadeIn();
                                  $(".slide5_img6").fadeIn();
                                })
                                $(".speech5").delay(2500).fadeIn();

                                $(".icon").css({
                                  "transform" : "translate(-10% , -35%) scale(1)",
                                  "trasition" : "" ,
                                  "box-shadow" : ""
                                })
                                break;
                        case 5 : $(".slide6_img1 , .slide6_img2").fadeIn();

                                  var gifSource5 = $('.circle5').attr('src');
                                  $('.circle5').attr('src', "");
                                  $('.circle5').attr('src', gifSource5+"?"+new Date().getTime());

                                  $(".circle5").delay(500).fadeIn();
                                  $(".speech6").delay(1500).fadeIn();
                                  $(".slide6_img3").delay(2250).fadeIn();

                                  $(".banner").css({
                                    "width" : "220px",
                                    "box-shadow" : "",
                                    "trasition" : ""
                                  })
                                  break;

                      }
                   }
                }
             }
         }
    },
    components: {
        swiper,
        swiperSlide
    },
}

</script>

<style lang="css" scoped>
* {
    margin: 0;
    padding: 0;
    list-style: none;
    box-sizing: border-box;
}
.con_wrap {
  display: flex;
  position: fixed;
  width: 90%;
  margin: 0 auto;
  padding: 40px 15px;
  z-index: 5;
}
.title {
  font-size: 1.3em;
  color: #1E90FF;
}
.back {
  height: 45px;
  padding: 15px 0;
}
.back img {
  width: 30px;
}
.logo {
  position: fixed;
  top: 10%;
  left: 50%;
  transform: translateX(-50%);
  width: 90%;
  height: 80px;
  text-align: center;
  border-radius: 10px;
  box-shadow : 0 2px 4px 0 rgb(0 0 0 / 15%), 0 3px 10px 0 rgb(0 0 0 / 14%);
  z-index: 5;

}
.logo img {
  width: 150px;
  margin-top: 20px;
}
#sec{
  border: 1px solid red;
}
p {
  color: black;
  font-family: 'Noto Sans KR', sans-serif;
}
.swiper-slide {
    height: 100%;
    font-size: 18px;
    background: #fff;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    position: relative;
}
.swiper-slide div {
  position: relative;
  width: 225px;
  height: 100%;
}
.swiper-slide div img {
    position: absolute;
    width: 300px;
    left: 50%;
    top: 45%;
    transform: translate(-50% , -50%);
    display: none;
}
.swiper-slide p {
    font-weight: bold;
    text-align: center;
    display: none;
    position: absolute;
    top: 70%;
}
.swiper-slide p span {
    color: #1d9cd3;
}
#timer {
  font-family: arial;
  position: absolute;
  top: 30.4%;
  left: 53.5%;
  transform: translate(-50% , -50%);
}

.skip {
    position: absolute;
    width: 100%;
    height: 80px;
    background-color: #1d9cd3;
    left: 0;
    bottom: 0;
    z-index: 2;
}

.skip p {
    text-align: center;
    line-height: 80px;
    font-weight: bold;
    font-size: 1.3em;
}
.skip p a {
    text-decoration: none;
    color: white;
}
.icon {
  position: absolute;
  top: 45%;
  left: 70%;
  transform: translate(-10% , -35%);
  width: 34px;
  height: 33px;
  background-color: #5fa9f0;
  display: none;

}
.icon img{
  display: block;
  width: 10px;
  margin: 12px auto;
}
.banner {
  width: 200px;
}

@media screen and (max-height:450px) {
  .logo {
    width: 20%;
    top: 5%;
  }
  .logo img {
      width: 100px;
      margin-top: 25px;
  }
  .swiper-slide {
      height: 100%;
      flex-direction: row;
      justify-content: space-around;

  }
  .slide2_img2 {
    width: 200px;
    max-width: 200px;
    trasition: all 1s ease;
  }
  .slide3_img3 {
    max-width: 200px;
    trasition: all 1s ease;
  }
  .swiper-slide div img {
      width: 200px;
      left: 40%;
  }
  .icon {
    width: 20px;
    height: 20px;
    left: 25%;
  }
  .icon img {
    width: 7px;
    margin-top: 7px;
  }
  .swiper-slide p {
      width: 30%;
      position: static;
      z-index: 10;
      margin-left: 100px;
      margin-bottom: 50px;
      font-size: 0.7em
  }
  .swiper-pagination {
    top: 75%;
  }
  .banner {
    width: 150px;
    max-width: 170px;
  }
}
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+KR:wght@300&display=swap');
</style>
